import { render, staticRenderFns } from "./ProductVehicleTypesForm.vue?vue&type=template&id=d97b48ca&scoped=true&"
import script from "./ProductVehicleTypesForm.vue?vue&type=script&lang=js&"
export * from "./ProductVehicleTypesForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductVehicleTypesForm.vue?vue&type=style&index=0&id=d97b48ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b48ca",
  null
  
)

export default component.exports